import { Map as ImmMap } from 'immutable';
import { SHOW_DIALOG, CLOSE_DIALOG } from './constants';

export const initialState = new ImmMap({
	isDialogVisible: false,
});

const dialogReducer = (state = initialState, action) => {
	switch (action.type) {
		case SHOW_DIALOG:
			return state.set('isDialogVisible', true);
		case CLOSE_DIALOG:
			return state.set('isDialogVisible', false);
		default:
			return state;
	}
};

export default dialogReducer;
